<template>
  <div id="sidebar" class="sidebar-left">
    <div class="sidebar_inner">
      <div class="list-group no-border list-unstyled">

        <div v-show="verifyUserRole(['admin', 'client_admin', 'staffer'])">
          <span class="list-group-item heading">Manage Events</span>
          <div v-show="verifyUserRole(['admin', 'client_admin'])">
            <router-link to="/users/events/new" class="list-group-item"
              :class="{ active: (tab === 'createEvent')}">
              <span >
                <i class="icon fa fa-calendar-o"></i> &nbsp; Add Event
              </span>
            </router-link>
          </div>
          <div v-show="verifyUserRole(['admin', 'client_admin', 'staffer'])">
            <router-link to="/users/events" class="list-group-item"
              :class="{ active: (tab.match(/userEvents|editEvent|showEvent/))}">
              <span >
                <i class="icon fa fa-calendar"></i> &nbsp; My Events
              </span>
            </router-link>
          </div>
        </div>

        <div v-show="verifyUserRole(['admin', 'client_admin', 'staffer'])">
          <span class="list-group-item heading">Manage Gift Cards</span>
          <div v-show="verifyUserRole(['admin', 'client_admin', 'staffer'])">
            <router-link to="/users/gift_cards" class="list-group-item"
              :class="{ active: (tab === 'userGiftCards')}">
              <span >
                <i class="icon fa fa-credit-card-alt"></i> &nbsp; Gift Cards
              </span>
            </router-link>
          </div>
        </div>

        <span class="list-group-item heading">Manage Account</span>
        <router-link to="/users/profile/organizer-profile" class="list-group-item"
          :class="{ active: (tab === 'organizerProfile')}">
          <span >
            <i class="icon fa fa-address-card"></i> &nbsp; Organizer Profile
          </span>
        </router-link>
        <router-link to="/users/profile/my-profile" class="list-group-item"
          :class="{ active: (tab === 'userProfile')}">
          <span >
            <i class="icon fa fa-pencil"></i> &nbsp; My Profile
          </span>
        </router-link>
        <router-link to="/users/profile/change-password" class="list-group-item"
          :class="{ active: (tab === 'userChangePassword')}">
          <span >
            <i class="icon fa fa-lock"></i> &nbsp; Change Password
          </span>
        </router-link>

        <div v-show="verifyUserRole(['admin', 'client_admin', 'member', 'guest'])">
          <span class="list-group-item heading">Stripe Account</span>
          <router-link to="/users/stripe-account" class="list-group-item"
            :class="{ active: (tab === 'stripeAccount')}">
            <span >
              <i class="icon fa fa-cc-stripe"></i> &nbsp; Connect
            </span>
          </router-link>
        </div>

        <div v-show="verifyUserRole(['admin', 'client_admin'])">
          <span class="list-group-item heading">Manage Staffers</span>
          <router-link to="/users/staffers" class="list-group-item"
            :class="{ active: (tab.match(/staffers|stafferForm/))}">
            <span >
              <i class="icon fa fa-users"></i> &nbsp; My Staffers
            </span>
          </router-link>
        </div>

        <div v-show="verifyUserRole(['admin', 'client_admin'])">
          <span class="list-group-item heading">Analytics</span>
          <router-link to="/users/analytics" class="list-group-item"
            :class="{ active: (tab.match(/analyticsForm/))}">
            <span >
              <i class="icon fa fa-bar-chart"></i> &nbsp; Integrations
            </span>
          </router-link>
        </div>

        <div v-show="verifyUserRole(['admin', 'client_admin'])">
          <span class="list-group-item heading">Site Configuration</span>
          <router-link to="/users/site-integration" class="list-group-item"
            :class="{ active: (tab.match(/siteIntegrationForm/))}">
            <span >
              <i class="icon fa fa-globe"></i> &nbsp; Technical Integration
            </span>
          </router-link>
        </div>

        <div v-show="verifyUserRole(['admin'])">
          <span class="list-group-item heading">Admin</span>
          <router-link to="/admin/application-settings" class="list-group-item"
            :class="{ active: (tab === 'applicationSettings')}">
            <span >
              <i class="icon fa fa-cog"></i> &nbsp; Application Settings
            </span>
          </router-link>

          <router-link to="/admin/sites-integration" class="list-group-item"
            :class="{ active: (tab === 'IntegratedSites')}">
            <span >
              <i class="icon fa fa-sitemap"></i> &nbsp; Integrated Sites
            </span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'layout-sidenav',
  data: function () {
    return {
      tab: null
    }
  },
  created: function () {
    this.tab = this.$route.name
  },
  watch: {
    '$route' (to, from) {
      this.tab = this.$route.name
    }
  },
  methods: {
    changeTab (value) {
      this.tab = value
    },
    verifyUserRole (roles) {
      return this.$root.getUserType && roles.includes(this.$root.getUserType)
    }
  }
}
</script>
